/**
 * Coups de pouce — Attendu 650 « Effectuer des calculs sur des horaires et
 * des durées ».
 *
 * VARIANTES routées par contenu.sousType (structurel, posé par la branche du
 * gen — décision utilisateur 2026-08-01, motifs texte jugés trop fragiles).
 * Structure des fiches (retour utilisateur) : page 1 = cadrage (« ce qu'on
 * connaît / ce qu'on cherche ») + geste + garde-fou des 60 ; page 2 =
 * mini-énoncé + droite du temps ANIMÉE annotée Départ / Arrivée / Durée.
 * Exemples HORS pools (départs 19 h+, arrivées 23 h+). `defaut` : fiche
 * générale (anciennes questions en banque sans sousType).
 */

const SVG_ARRIVEE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 142" width="310" height="133" role="img"
     aria-label="Droite du temps : du départ 19 h 40, plus 20 minutes jusqu'à 20 h pile, plus 1 heure, plus 15 minutes : arrivée 21 h 15. Les trois sauts font bien 1 h 35 min, toute la durée est ajoutée">
  <style>
    .anim { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .s1 { opacity: 0; animation: cp650w 6.4s linear infinite 0.0s; }
      .s2 { opacity: 0; animation: cp650w 6.4s linear infinite 1.6s; }
      .s3 { opacity: 0; animation: cp650w 6.4s linear infinite 3.2s; }
      .s4 { opacity: 0; animation: cp650w 6.4s linear infinite 4.8s; }
    }
    @keyframes cp650w { 0%, 4% { opacity: 0; } 10%, 92% { opacity: 1; } 97%, 100% { opacity: 0; } }
  </style>
  <line x1="10" y1="78" x2="320" y2="78" stroke="#0f172a" stroke-width="2"/>
  <polygon points="320,78 312,74 312,82" fill="#0f172a"/>
  <line x1="32" y1="72" x2="32" y2="84" stroke="#0f172a" stroke-width="2"/>
  <text x="32" y="98" text-anchor="middle" font-size="12" fill="#0f172a">19 h 40</text>
  <text x="32" y="114" text-anchor="middle" font-size="11.5" font-weight="bold" fill="#64748b">Départ</text>
  <line x1="110" y1="69" x2="110" y2="87" stroke="#0f172a" stroke-width="2.5"/>
  <text x="110" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#0f172a">20 h 00</text>
  <line x1="215" y1="69" x2="215" y2="87" stroke="#0f172a" stroke-width="2.5"/>
  <text x="215" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#0f172a">21 h 00</text>
  <line x1="298" y1="72" x2="298" y2="84" stroke="#0f172a" stroke-width="2"/>
  <text class="anim s4" x="298" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#fb923c">21 h 15</text>
  <text class="anim s4" x="298" y="114" text-anchor="middle" font-size="11.5" font-weight="bold" fill="#fb923c">Arrivée</text>
  <g class="anim s1">
    <path d="M 32 68 Q 71.0 26 110 68" fill="none" stroke="#fb923c" stroke-width="2.5"/>
    <polygon points="110,68 102,62 107,56" fill="#fb923c"/>
    <text x="71.0" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#fb923c">+ 20 min</text>
  </g>
  <g class="anim s2">
    <path d="M 110 68 Q 162.5 26 215 68" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <polygon points="215,68 207,62 212,56" fill="#f97316"/>
    <text x="162.5" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#f97316">+ 1 h</text>
  </g>
  <g class="anim s3">
    <path d="M 215 68 Q 256.5 26 298 68" fill="none" stroke="#ea580c" stroke-width="2.5"/>
    <polygon points="298,68 290,62 295,56" fill="#ea580c"/>
    <text x="256.5" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#ea580c">+ 15 min</text>
  </g>
  <text class="anim s4" x="165.0" y="136" text-anchor="middle" font-size="12.5" font-weight="bold" fill="#fb923c">20 min + 1 h + 15 min = 1 h 35 min : toute la durée ✓</text>
</svg>`.trim();

const SVG_DEPART = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 142" width="310" height="133" role="img"
     aria-label="Droite du temps : de l'arrivée 23 h 05, on recule de 5 minutes, puis d'une heure, puis de 20 minutes : départ 21 h 40. Les trois sauts font bien 1 h 25 min, toute la durée est enlevée">
  <style>
    .anim { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .s1 { opacity: 0; animation: cp650w 6.4s linear infinite 0.0s; }
      .s2 { opacity: 0; animation: cp650w 6.4s linear infinite 1.6s; }
      .s3 { opacity: 0; animation: cp650w 6.4s linear infinite 3.2s; }
      .s4 { opacity: 0; animation: cp650w 6.4s linear infinite 4.8s; }
    }
    @keyframes cp650w { 0%, 4% { opacity: 0; } 10%, 92% { opacity: 1; } 97%, 100% { opacity: 0; } }
  </style>
  <line x1="10" y1="78" x2="320" y2="78" stroke="#0f172a" stroke-width="2"/>
  <polygon points="320,78 312,74 312,82" fill="#0f172a"/>
  <line x1="32" y1="72" x2="32" y2="84" stroke="#0f172a" stroke-width="2"/>
  <text class="anim s4" x="32" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#fb923c">21 h 40</text>
  <text class="anim s4" x="32" y="114" text-anchor="middle" font-size="11.5" font-weight="bold" fill="#fb923c">Départ</text>
  <line x1="110" y1="69" x2="110" y2="87" stroke="#0f172a" stroke-width="2.5"/>
  <text x="110" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#0f172a">22 h 00</text>
  <line x1="215" y1="69" x2="215" y2="87" stroke="#0f172a" stroke-width="2.5"/>
  <text x="215" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#0f172a">23 h 00</text>
  <line x1="298" y1="72" x2="298" y2="84" stroke="#0f172a" stroke-width="2"/>
  <text x="298" y="98" text-anchor="middle" font-size="12" fill="#0f172a">23 h 05</text>
  <text x="298" y="114" text-anchor="middle" font-size="11.5" font-weight="bold" fill="#64748b">Arrivée</text>
  <g class="anim s1">
    <path d="M 298 68 Q 256.5 26 215 68" fill="none" stroke="#fb923c" stroke-width="2.5"/>
    <polygon points="215,68 223,62 218,56" fill="#fb923c"/>
    <text x="256.5" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#fb923c">− 5 min</text>
  </g>
  <g class="anim s2">
    <path d="M 215 68 Q 162.5 26 110 68" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <polygon points="110,68 118,62 113,56" fill="#f97316"/>
    <text x="162.5" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#f97316">− 1 h</text>
  </g>
  <g class="anim s3">
    <path d="M 110 68 Q 71.0 26 32 68" fill="none" stroke="#ea580c" stroke-width="2.5"/>
    <polygon points="32,68 40,62 35,56" fill="#ea580c"/>
    <text x="71.0" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#ea580c">− 20 min</text>
  </g>
  <text class="anim s4" x="165.0" y="136" text-anchor="middle" font-size="12.5" font-weight="bold" fill="#fb923c">5 min + 1 h + 20 min = 1 h 25 min : toute la durée ✓</text>
</svg>`.trim();

const SVG_DUREE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 142" width="310" height="133" role="img"
     aria-label="Droite du temps : du départ 19 h 25 à l'arrivée 21 h 30, les sauts font 35 minutes puis 1 heure puis 30 minutes, durée 1 h 65 min convertie en 2 h 05 min">
  <style>
    .anim { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .s1 { opacity: 0; animation: cp650w 6.4s linear infinite 0.0s; }
      .s2 { opacity: 0; animation: cp650w 6.4s linear infinite 1.6s; }
      .s3 { opacity: 0; animation: cp650w 6.4s linear infinite 3.2s; }
      .s4 { opacity: 0; animation: cp650w 6.4s linear infinite 4.8s; }
    }
    @keyframes cp650w { 0%, 4% { opacity: 0; } 10%, 92% { opacity: 1; } 97%, 100% { opacity: 0; } }
  </style>
  <line x1="10" y1="78" x2="320" y2="78" stroke="#0f172a" stroke-width="2"/>
  <polygon points="320,78 312,74 312,82" fill="#0f172a"/>
  <line x1="32" y1="72" x2="32" y2="84" stroke="#0f172a" stroke-width="2"/>
  <text x="32" y="98" text-anchor="middle" font-size="12" fill="#0f172a">19 h 25</text>
  <text x="32" y="114" text-anchor="middle" font-size="11.5" font-weight="bold" fill="#64748b">Départ</text>
  <line x1="110" y1="69" x2="110" y2="87" stroke="#0f172a" stroke-width="2.5"/>
  <text x="110" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#0f172a">20 h 00</text>
  <line x1="215" y1="69" x2="215" y2="87" stroke="#0f172a" stroke-width="2.5"/>
  <text x="215" y="98" text-anchor="middle" font-size="12" font-weight="bold" fill="#0f172a">21 h 00</text>
  <line x1="298" y1="72" x2="298" y2="84" stroke="#0f172a" stroke-width="2"/>
  <text x="298" y="98" text-anchor="middle" font-size="12" fill="#0f172a">21 h 30</text>
  <text x="298" y="114" text-anchor="middle" font-size="11.5" font-weight="bold" fill="#64748b">Arrivée</text>
  <g class="anim s1">
    <path d="M 32 68 Q 71.0 26 110 68" fill="none" stroke="#fb923c" stroke-width="2.5"/>
    <polygon points="110,68 102,62 107,56" fill="#fb923c"/>
    <text x="71.0" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#fb923c">35 min</text>
  </g>
  <g class="anim s2">
    <path d="M 110 68 Q 162.5 26 215 68" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <polygon points="215,68 207,62 212,56" fill="#f97316"/>
    <text x="162.5" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#f97316">1 h</text>
  </g>
  <g class="anim s3">
    <path d="M 215 68 Q 256.5 26 298 68" fill="none" stroke="#ea580c" stroke-width="2.5"/>
    <polygon points="298,68 290,62 295,56" fill="#ea580c"/>
    <text x="256.5" y="36" text-anchor="middle" font-size="12" font-weight="bold" fill="#ea580c">30 min</text>
  </g>
  <text class="anim s4" x="165.0" y="136" text-anchor="middle" font-size="12.5" font-weight="bold" fill="#fb923c">Durée : 35 min + 1 h + 30 min = 1 h 65 min = 2 h 05 min</text>
</svg>`.trim();

const LIGNE_60 = 'Attention : une heure = **60** minutes, pas 100.';

const FICHE_ARRIVEE = {
    pages: [
        {
            titre: 'Passe par l\'heure pile',
            lignes: [
                'Tu connais l\'heure de **départ** et la **durée** ; tu cherches l\'heure d\'**arrivée** : pars du départ et **avance**.',
                '**Découpe la durée à ajouter** : d\'abord juste ce qu\'il faut pour tomber sur une **heure pile**, puis le reste de la durée.',
                LIGNE_60,
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Départ : **19 h 40**. Durée : **1 h 35 min**. Heure d\'arrivée ?',
                'On ajoute **20 min** : 20 h 00. Puis **1 h** : 21 h 00. Puis **15 min** : **21 h 15**.',
            ],
            svg: SVG_ARRIVEE,
        },
    ],
};

const FICHE_DEPART = {
    pages: [
        {
            titre: 'Recule par l\'heure pile',
            lignes: [
                'Tu connais l\'heure d\'**arrivée** et la **durée** du trajet ; tu cherches l\'heure de **départ** : pars de l\'arrivée et **recule**.',
                '**Découpe la durée à enlever** : d\'abord juste ce qu\'il faut pour tomber sur une **heure pile**, puis le reste de la durée.',
                LIGNE_60,
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Arrivée : **23 h 05**. Durée : **1 h 25 min**. Heure de départ ?',
                'On enlève **5 min** : 23 h 00. Puis **1 h** : 22 h 00. Puis **20 min** : **21 h 40**.',
            ],
            svg: SVG_DEPART,
        },
    ],
};

const FICHE_DUREE = {
    pages: [
        {
            titre: 'Additionne les sauts',
            lignes: [
                'Tu connais l\'heure de **départ** et l\'heure d\'**arrivée** ; tu cherches la **durée** entre les deux.',
                'Pars de l\'heure de **départ**, avance d\'**heure pile** en heure pile jusqu\'à l\'arrivée, puis **additionne tes sauts**.',
                LIGNE_60,
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Départ : **19 h 25**. Arrivée : **21 h 30**. Durée du trajet ?',
                '**35 min** + **1 h** + **30 min** = 1 h 65 min. Comme 65 ≥ 60, on convertit : **2 h 05 min**.',
            ],
            svg: SVG_DUREE,
        },
    ],
};

// Fiche générale : filet pour les questions déjà en banque (sans sousType).
const FICHE_GENERALE = {
    pages: [
        {
            titre: 'Passe par l\'heure pile',
            lignes: [
                'Pour ajouter ou enlever une durée, va d\'abord jusqu\'à l\'**heure pile** la plus proche, puis continue.',
                LIGNE_60,
            ],
        },
        {
            titre: 'Les trois calculs',
            lignes: [
                '**Heure de fin** : 19 h 40 + 1 h 35 min : on ajoute 20 min, puis 1 h, puis 15 min : **21 h 15**.',
                '**Heure de départ** : 23 h 05 − 1 h 25 min : on enlève 5 min, puis 1 h, puis 20 min : **21 h 40**.',
                '**Durée** : de 19 h 25 à 21 h 30 : 35 min + 1 h + 30 min = 1 h 65 min = **2 h 05 min**.',
            ],
            svg: SVG_ARRIVEE,
        },
    ],
};

// Fiche DÉDIÉE au format trous guidé (revue 2026-08-01) : son échafaudage
// enseigne la méthode ARITHMÉTIQUE (ajouter les heures, puis les minutes,
// convertir si ≥ 60) — la fiche « heure pile » ne collait pas (retour
// utilisateur). Page 2 = miroir exact de l\'échafaudage, jusqu\'à la formule
// « Comme X ≥ 60, on convertit ». Valeurs hors pools (départs ≤ 18 h).
// Pas de droite du temps : la méthode est symbolique.
// Conversion animée : le paquet de 60 min quitte les minutes et devient
// une heure de plus (retour utilisateur). Même motif CSS que les droites.
const SVG_CONVERSION = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 138" width="300" height="125" role="img"
     aria-label="Conversion : 21 h 72 minutes ; 72 minutes se découpent en 60 minutes plus 12 minutes ; les 60 minutes deviennent une heure de plus : la nouvelle rangée affiche 22 h 12">
  <style>
    .anim { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .c1 { opacity: 0; animation: cp650conv 6.4s linear infinite 0s; }
      .c2 { opacity: 0; animation: cp650conv 6.4s linear infinite 1.6s; }
      .c3 { opacity: 0; animation: cp650conv 6.4s linear infinite 3.2s; }
      .c4 { opacity: 0; animation: cp650conv 6.4s linear infinite 4.8s; }
    }
    @keyframes cp650conv { 0%, 4% { opacity: 0; } 10%, 92% { opacity: 1; } 97%, 100% { opacity: 0; } }
  </style>
  <rect x="40" y="10" width="60" height="30" rx="6" fill="none" stroke="#0f172a" stroke-width="2"/>
  <text x="70" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#0f172a">21 h</text>
  <g class="anim c1">
    <rect x="110" y="10" width="78" height="30" rx="6" fill="none" stroke="#fb923c" stroke-width="2.5"/>
    <text x="149" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#fb923c">72 min</text>
    <text x="200" y="30" font-size="12" fill="#64748b">trop grand !</text>
  </g>
  <g class="anim c2">
    <text x="110" y="62" font-size="13.5" fill="#0f172a">= <tspan font-weight="bold" fill="#fb923c">60 min</tspan> + 12 min</text>
  </g>
  <g class="anim c3">
    <path d="M 130 68 Q 70 74 70 92" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <polygon points="70,98 65,88 76,88" fill="#f97316"/>
    <text x="60" y="76" text-anchor="end" font-size="13.5" font-weight="bold" fill="#f97316">+ 1 h</text>
    <rect x="40" y="100" width="60" height="30" rx="6" fill="none" stroke="#f97316" stroke-width="2.5"/>
    <text x="70" y="120" text-anchor="middle" font-size="15" font-weight="bold" fill="#f97316">22 h</text>
  </g>
  <g class="anim c4">
    <rect x="110" y="100" width="78" height="30" rx="6" fill="none" stroke="#fb923c" stroke-width="2.5"/>
    <text x="149" y="120" text-anchor="middle" font-size="15" font-weight="bold" fill="#fb923c">12 min</text>
    <text x="208" y="121" font-size="17" font-weight="bold" fill="#fb923c">✓</text>
  </g>
</svg>`.trim();

const FICHE_TROUS_GUIDE = {
    pages: [
        {
            titre: 'Ajoute, puis convertis',
            lignes: [
                'Ajoute d\'abord les **heures**, puis les **minutes**.',
                'Si les minutes dépassent **59**, convertis : enlève **60 min** et ajoute **1 h**.',
            ],
        },
        {
            titre: 'Un exemple',
            lignes: [
                'Départ : **19 h 47**. Durée : **2 h 25 min**.',
                'On ajoute 2 h : 21 h 47. Puis 25 min : 21 h **72** min.',
                'Comme 72 ≥ 60, on convertit : **22 h 12**.',
            ],
            svg: SVG_CONVERSION,
        },
    ],
};

const VARIANTES_HORAIRES = {
    variantes: [
        { sousType: 'final', pages: FICHE_ARRIVEE.pages },
        { sousType: 'initial', pages: FICHE_DEPART.pages },
        { sousType: 'duree', pages: FICHE_DUREE.pages },
    ],
    defaut: FICHE_GENERALE,
};

const CP_650 = {
    calcul_horaire_qcm_unique: VARIANTES_HORAIRES,
    calcul_horaire_texte: VARIANTES_HORAIRES,
    calcul_horaire_texte_trou_saisie: FICHE_TROUS_GUIDE,
    calcul_horaire_relier: VARIANTES_HORAIRES,
};

export default CP_650;
